import { PaymentItemType } from "./const.mjs";
//#region src/payment/order.ts
const OrderType = {
	purchase: "purchase",
	renewal: "renewal",
	charge: "charge",
	withdraw: "withdraw",
	privilege: "privilege",
	subscription_update: "subscription_update",
	payment_notification: "payment_notification",
	gift: "gift",
	op: "op",
	extra_package: PaymentItemType.ExtraPackage,
	event_pass: "event_pass",
	surprise_pack: "surprise_pack",
	kotone: "kotone",
	kotone_credit_exchange: "kotone_credit_exchange",
	kotone_monthly_membership_grant: "kotone_monthly_membership_grant"
};
const OrderStatus = {
	init: "init",
	unpaid: "unpaid",
	expired: "expired",
	paid: "paid",
	completed: "completed",
	cancelled: "cancelled",
	failed: "failed",
	refund_pending: "refund_pending",
	refunded: "refunded"
};
/** Order statuses that represent a final state — no further transitions expected. */
const TERMINAL_ORDER_STATUSES = new Set([
	OrderStatus.completed,
	OrderStatus.failed,
	OrderStatus.cancelled,
	OrderStatus.expired,
	OrderStatus.refunded
]);
function isTerminalOrderStatus(status) {
	return TERMINAL_ORDER_STATUSES.has(status);
}
/**
* Order types that bypass all PixAI-side status-change and post-completion hooks
* (extraPackageBoost, Sift, revenue tracking, referral, fulfillment, etc.).
* Kotone-managed orders handle their own lifecycle on the kotone side.
*/
const SELF_MANAGED_ORDER_TYPES = new Set([
	OrderType.kotone,
	OrderType.kotone_credit_exchange,
	OrderType.kotone_monthly_membership_grant
]);
//#endregion
export { OrderStatus, OrderType, SELF_MANAGED_ORDER_TYPES, TERMINAL_ORDER_STATUSES, isTerminalOrderStatus };
